<template>
  <div class="trial-action-bar">
    <template v-if="trial.status == 'draft'">
      <div
      :class="{ active: canRun }"
      class="btn btn--secondary run-button"
      @click.stop="() => canRun && onConfirmClick()"
    >{{$t('confirm')}}</div>
    </template>
    <template v-if="trial.status == 'ready'">
      <template v-if="expanded">
        <div
        :class="{disabled: pendingAction}"
        class="btn-rounded edit-button"
        @click.stop="() =>!pendingAction && onEditClick()"
        v-tooltip="'Edit'"
        ><div class="edit-icon"></div>
          {{$t('edit')}}
        </div>
      </template>
      <template v-else>
        <div
          :class="{active: !pendingAction}"
          class="action-button  edit-button"
          @click.stop="() =>!pendingAction && onEditClick()"
          v-tooltip="'Edit'"
        ></div>
      </template>
      <button
        :disabled="pendingAction"
        class="btn btn--secondary run-button"
        @click.stop="() =>!pendingAction && onSubmitClick()"
        v-if="!expanded"
      >{{pendingAction? $t('processing') : $t('submit')}}</button>
    </template>
    <template v-if="trial.status == 'submitted' || trial.status == 'deploying'">
      <button v-if="this.$store.state.user.is_superuser && !expanded"
        :disabled="pendingAction"
        class="btn btn--secondary run-button"
        @click.stop="() =>!pendingAction && onRunClick()"
      > {{$t('run')}}</button>
      <button v-if="!this.$store.state.user.is_superuser && !expanded"
        :disabled="true"
        class="btn btn--secondary run-button"
      > {{$t('validating')}}</button>
    </template>
    <!-- Once we get the pause/resume button properly working, uncomment next lines -->
    <template v-if="trial.status == 'running'"></template>
    <template v-if="trial.status == 'paused'"></template>
    <!-- <template v-if="trial.status == 'running'">
      <template v-if="expanded">
        <div
        class="btn-rounded active pause-button"
        @click.stop="() => onEditClick()"
        v-tooltip="'Pause'"
        ><div class="pause-icon"></div>
          {{$t('Pause')}}
        </div>
      </template>
      <template v-else>
        <div
          class="action-button active pause-button"
          @click.stop="() => canPause && onPauseClicked()"
          v-tooltip="'Pause'"
        ></div>
      </template>
    </template> -->
    <!-- <template v-if="trial.status == 'paused'">
      <div
          class="action-button active run-button"
          @click.stop="() => canRun && onRunConfirmed()"
          v-tooltip="'Resume'"
        ></div>
    </template> -->
    <template v-if="trial.status == 'finished'">
      <div
      class="btn btn--primary view-results-btn"
      @click.stop="() => goToTrialResults()"
    >Trial results<!-- {{$t("view_results")}} --></div>
    </template>
    <template v-if="trial.status == 'cancelled' || trial.status == 'aborted'">
    </template>
    <div
      class="btn-rounded btn-close"
      @click.stop="() => onClose()"
      v-tooltip="'Close'"
      v-if="expanded"
      >
      <div class="close-icon"></div>
      {{$t('Close')}}
    </div>
    <div v-if="this.error" class="error-icon" v-tooltip="this.error"></div>
    <div class="contextual-menu" v-if="!expanded">
      <multiple-actions-menu
        :options="actionsOptions"
        @onAction="onContextAction"
        v-on:click.stop
      ></multiple-actions-menu>
    </div>
</div>
</template>

<script>
import MultipleActionsMenu from '@/components/commons/MultipleActionsMenu'
import Api from '@/api'
import store from '@/store'

export default {
  name: "TrialActionBar",
  props:['trial', "expanded"],
  components: {MultipleActionsMenu},
  data () {
    return {
      pendingAction: false,
      error: ''
    }
  },
  computed: {
    actionsOptions() {
      let availableActions = [
        {label:'Download', event:'download'},
        {label:'Duplicate', event:'duplicate'},
        {label:'Cancel', event:'cancel'}
      ]
      if(['cancelled', 'running'].includes(this.trial.status)) availableActions.splice(2,1)
      if (!this.$store.state.user.is_superuser) availableActions.splice(0,1)
      return availableActions
    },
    canEdit() {
      return ['draft'].includes(this.trial.status)
    },
    canPause() {
      return ['running'].includes(this.trial.status)
    },
    canRun(){
      return ['draft', 'paused'].includes(this.trial.status)
    },
    canDraft() {
      return ['ready'].includes(this.trial.status)
    },
    hasResults () {
      return this.trial.status == 'finished'
    },
  },
  methods: {
    onEditClick(){
      Api.setTrialStatus(this.trial,'draft').then(()=>{
        if(this.$route.name != "TrialEditView"){
          this.$router.push({path: `/project/${this.trial.projectId}/trial/${this.trial.id}`})
        }
      })
    },
    onConfirmClick (){
      Api.setTrialStatus(this.trial, "ready")
    },
    onSubmitClick(){
      this.$modal.show('run-trial',{
        trial: this.trial,
        runningCallback: this.onRunConfirmed
      })
    },
    onRunClick() {
      Api.setTrialStatus(this.trial, "running")
    },
    onRunConfirmed(){
      this.pendingAction = true
      this.error = ''
      Api.setTrialStatus(this.trial,'submitted').then(()=>{
        store.dispatch('updateOrganisationTokens')
        this.pendingAction = false
      }).catch(err => {
        console.log(err)
        this.pendingAction = false
        this.error = 'Error running trial'
      })
    },
    onPauseClicked () {
      // POST
      console.log("should show confirmation")
      this.$modal.show('dialog', {
        title: 'Pause trial',
        text:`This trial is currently running, are you sure you want to pause it?`,
        buttons: [
          {
            title: 'Cancel',
            handler: () => this.$modal.hide('dialog')
          },
          {
            title: 'Yes',
            handler: () => {
              this.pauseTrial()
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    onClose() {
      this.$router.push({path: `/project/${this.trial.projectId}/`})
    },
    pauseTrial () {
      this.pendingAction = true
      this.error = ''
      Api.setTrialStatus(this.trial,'paused').then(()=>{
        console.log("trial status udpated (to paused)")
        this.pendingAction = false
      }).catch(err => {
        console.log(err)
        this.pendingAction = false
        this.error = 'Error pausing trial'
      })
    },
    cancelTrial () {
      this.pendingAction = true
      this.error = ''
      Api.setTrialStatus(this.trial,'cancelled').then(()=>{
        console.log("trial status udpated (to paused)")
        this.pendingAction = false
      }).catch(err => {
        console.log(err)
        this.pendingAction = false
        this.error = 'Error canceling trial'
      })
    },
    onCancelClicked () {
      // POST
      console.log("should show confirmation")
      this.$modal.show('dialog', {
        title: 'Cancel trial',
        text:`Are you sure you want to cancel this trial?`,
        buttons: [
          {
            title: 'No',
            handler: () => this.$modal.hide('dialog')
          },
          {
            title: 'Yes',
            handler: () => {
              this.cancelTrial()
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    onContextAction(evt) {
      if(evt==='cancel') this.onCancelClicked()
      this.$emit(evt)
    },
    goToTrialResults () {
      this.$store.state.trialToShowInResultsCrumb = `trial#${this.trial.id}`
      this.$router.push({path: `/project/${this.trial.projectId}/results`})
    }
  }

}
</script>

<style lang="stylus" scoped>
.trial-action-bar
  display flex
  align-items: center
  .error-icon
    m-icon("alert", 16)
  .btn, .btn-rounded, .action-button 
    margin-right 15px
  .btn-close
    margin-right 0px
  .edit-icon
    m-icon("action-edit", 24)

  .pause-icon
    m-icon("action-pause", 24)

  .run-icon
    m-icon("action-play", 24)

  .close-icon
    m-icon("cross-blue", 12)
    margin-right 5px
</style>